module.exports = __webpack_public_path__ + "img/img_index_cha_01_3@2x.4d368ec8.png";